import comp from "./AITutorFlaggedMessages";
export default comp;
